{
  "shippingServices": {
    "ECONOMY": "Économique",
    "STANDARD": "Standard",
    "PRIORITY": "Prioritaire",
    "GROUND": "Terrestre",
    "INTL_STANDARD": "International standard",
    "INTL_EXPRESS": "International express",
    "NEXT_DAY": "Express 24 h",
    "INTERNATIONAL": "International"
  },
  "shippingZones": {
    "US_DOMESTIC": "National (É.-U.)",
    "US_HAWAII_AK": "Hawaï et Alaska",
    "CANADA": "Canada",
    "EU": "Union européenne",
    "UK": "Royaume-Uni",
    "AUSTRALIA": "Australie",
    "REST_OF_WORLD": "Reste du monde"
  },
  "initialsAvatar": {
    "noImage": "Aucune image"
  },
  "shippingFees": {
    "title": "Frais de livraison",
    "description": "Tableaux des frais de livraison (Shipping Rate Engine v2) — par pays de destination / grille ZIP3 (É.-U.) + exceptions ZIP5."
  },
  "blueprintCost": {
    "title": "Coût du blueprint",
    "description": "Lecture seule — coût de production du fournisseur par variante de blueprint. Le coût est géré côté fournisseur (attribution de capacité / approbation produit) ; cliquez sur un nom pour ouvrir la page Détail du blueprint.",
    "search": "Rechercher",
    "searchPlaceholder": "Rechercher par blueprint, SKU ou fournisseur…",
    "error": "Échec du chargement des coûts de blueprint.",
    "empty": "Aucun coût de blueprint ne correspond au filtre actuel.",
    "columns": {
      "blueprint": "Blueprint",
      "variantSku": "SKU de variante",
      "vendor": "Fournisseur",
      "productionCost": "Coût de production",
      "seasonalCost": "Coût saisonnier",
      "procDays": "Jours trait.",
      "quality": "Qualité",
      "country": "Pays",
      "status": "Statut"
    },
    "statusLabels": {
      "approved": "Approuvé",
      "pending_approval": "En attente d'approbation",
      "rejected": "Rejeté"
    },
    "pagination": {
      "prev": "Précédent",
      "next": "Suivant"
    }
  },
  "pricesV2": {
    "title": "Tarification",
    "subtitle": "Voir les produits avec tarification par palier",
    "exportAll": "Tout exporter",
    "networkError": "Échec du chargement des prix.",
    "empty": "Aucun blueprint correspondant",
    "searchPlaceholder": "Rechercher des produits ou SKU…",
    "allTiers": "Tous les paliers",
    "selectBlueprint": "Sélectionner {{name}}",
    "selectVariant": "Sélectionner {{sku}}",
    "variantsBadge_one": "{{count}} variante",
    "variantsBadge_other": "{{count}} variantes",
    "stats": {
      "products": "Produits",
      "variants": "Variantes",
      "skus": "SKU",
      "avgPrice": "Prix moyen",
      "avgShipping": "Livraison moyenne"
    },
    "expandAll": "Tout déplier",
    "collapseAll": "Tout replier",
    "shippingDisplay": "Livraison",
    "shippingInMatrix": "Dans le tableau",
    "shippingSidePanel": "Panneau latéral",
    "viewShipping": "Livraison",
    "table": {
      "sku": "SKU",
      "variant": "Variante",
      "pricing": "TARIFS",
      "shipping": "Livraison",
      "fee": "Frais",
      "extra": "Suppl.",
      "base": "Base"
    },
    "panel": {
      "title": "Frais de livraison",
      "method": "Méthode",
      "fee": "Frais",
      "extra": "Suppl. (2e+)",
      "close": "Fermer",
      "empty": "Aucun frais de livraison pour cette variante."
    }
  },
  "configPage": {
    "title": "Configuration des prix",
    "subtitle": "Surcoûts saisonniers, règles de broderie, taxe/tarif et numérisation — appliqués au prochain devis/confirmation.",
    "readOnly": "Vous avez besoin de la permission pricing:manage pour modifier ces paramètres.",
    "save": "Enregistrer la configuration",
    "saving": "Enregistrement…",
    "savedToast": "Configuration enregistrée.",
    "errorToast": "Impossible d'enregistrer la configuration.",
    "validationToast": "Veuillez corriger les champs surlignés.",
    "tabs": {
      "seasonal": "Saisonnier",
      "embroidery": "Broderie",
      "tax": "Taxe & tarif",
      "digitizing": "Numérisation"
    },
    "seasonal": {
      "title": "Surcoût saisonnier",
      "variantIdLabel": "ID de variante",
      "variantIdPlaceholder": "_id de variante",
      "feeLabel": "Frais saisonnier",
      "windowStartLabel": "Début de la fenêtre",
      "windowEndLabel": "Fin de la fenêtre",
      "bulkTitle": "Application groupée par plage de poids",
      "weightMinLabel": "Poids min (g)",
      "weightMaxLabel": "Poids max (g)",
      "bulkFeeLabel": "Frais à appliquer",
      "windowPassedReport": "Avertissement : frais saisonnier supérieur à 0 mais la fenêtre est déjà passée."
    },
    "embroidery": {
      "title": "Règles de points de broderie",
      "minStitchesLabel": "Points min",
      "maxStitchesLabel": "Points max",
      "feeLabel": "Frais pour la plage",
      "addRule": "Ajouter une règle",
      "removeRule": "Supprimer"
    },
    "tax": {
      "title": "Tarif réciproque",
      "vendorIdLabel": "ID fournisseur",
      "zoneLabel": "Zone de destination",
      "rateLabel": "Tarif par unité (USD)",
      "createTariff": "Créer un tarif",
      "blueprintIdLabel": "ID du blueprint"
    },
    "digitizing": {
      "title": "Frais de numérisation global",
      "feeLabel": "Frais de numérisation",
      "helper": "Facturé une fois par nouveau motif de broderie."
    }
  },
  "skuPrices": {
    "title": "Prix",
    "description": "Prix de vente par SKU et par emplacement pour chaque niveau actif, avec les frais d'expédition par service.",
    "search": {
      "placeholder": "Rechercher un blueprint, un SKU ou une variante",
      "aria": "Rechercher des prix"
    },
    "filters": {
      "location": "Emplacement",
      "category": "Catégorie",
      "vendor": "Fournisseur",
      "locationAria": "Filtrer par emplacement",
      "categoryAria": "Filtrer par catégorie",
      "vendorAria": "Filtrer par fournisseur",
      "clearHint": "Cliquez à nouveau pour effacer",
      "loadingOptions": "Chargement…",
      "loadError": "Impossible de charger les options",
      "searchPlaceholder": "Rechercher…",
      "searchAria": "Rechercher dans la liste",
      "noResults": "Aucun résultat",
      "searchError": "La recherche a échoué. Modifiez ou effacez la recherche.",
      "selectedFallback": "1 sélectionné"
    },
    "columns": {
      "blueprint": "Blueprint",
      "sku": "SKU",
      "variantName": "Nom de la variante",
      "location": "Emplacement",
      "tax": "Taxe",
      "tiktok": "Tiktok",
      "status": "Statut du blueprint",
      "variantStatus": "Statut de la variante",
      "shipFee": "Expédition ({{service}})",
      "shipSeasonal": "Saisonnier ({{service}})",
      "shipExtra": "Supplémentaire ({{service}})",
      "shipTariff": "Tarif réciproque ({{service}})",
      "shipParts": {
        "fee": "Expédition",
        "seasonal": "Saisonnier",
        "extra": "Supplémentaire",
        "tariff": "Tarif réciproque"
      },
      "toggle": "Colonnes",
      "reset": "Réinitialiser les colonnes",
      "saveError": "Impossible d'enregistrer l'affichage des colonnes. Modifications annulées."
    },
    "groups": {
      "pricing": "Tarification",
      "shipping": "Expédition : {{service}}"
    },
    "values": {
      "yes": "Oui",
      "no": "Non"
    },
    "status": {
      "Draft": "Brouillon",
      "PendingApproval": "En attente d'approbation",
      "Active": "Actif",
      "Inactive": "Inactif",
      "Archived": "Archivé",
      "InStock": "En stock",
      "OutOfStock": "Rupture de stock",
      "Discontinued": "Arrêté"
    },
    "blueprintStatus": {
      "Draft": "Brouillon",
      "PendingApproval": "En attente d'approbation",
      "Active": "Actif",
      "Inactive": "Inactif",
      "Archived": "Archivé"
    },
    "variantStatus": {
      "InStock": "En stock",
      "OutOfStock": "Rupture de stock",
      "Discontinued": "Arrêté"
    },
    "empty": {
      "cell": "—",
      "list": "Aucun prix ne correspond à ces filtres."
    },
    "error": {
      "load": "Impossible de charger les prix. Veuillez réessayer."
    },
    "pagination": {
      "rowsPerPage": "Lignes par page",
      "range": "Affichage {{from}}–{{to}} sur {{total}}",
      "prevPage": "Page précédente",
      "nextPage": "Page suivante",
      "aria": "Pagination des prix"
    },
    "export": {
      "button": "Exporter",
      "success": "{{count}} lignes exportées.",
      "error": "Échec de l'export. Veuillez réessayer."
    }
  }
}
